import {type PageView, postPageViews} from '@/api/logs'

const MAX_PAGES_BEFORE_SEND = 10
const SEND_INTERVAL_SECONDS = 60

class PageViewer {
  private pageViews: PageView[] = []
  private pageViewsHistory: PageView[] = []
  private timerId: number | null = null
  private lastSendTime: number = Date.now()

  constructor () {
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    this.startTimer()
  }

  public pageVisited (module: string, page: string, url: string, payload: Record<string, string> = {}) {
    const view: PageView = {
      module,
      page,
      view_time: new Date().toISOString(),
      payload: { ...payload, full_path: url },
    }
    this.pageViews.push(view)
    this.pageViewsHistory.push(view)
    if (this.pageViewsHistory.length > 20) {
      this.pageViewsHistory = this.pageViewsHistory.slice(-20) // Keep only the last 20 views
    }

    if (this.pageViews.length >= MAX_PAGES_BEFORE_SEND) {
      this.sendPageViews()
    }
  }

  public getPageViewsHistory (): PageView[] {
    return [...this.pageViewsHistory]
  }

  private sendPageViews = async () => {
    if (this.pageViews.length === 0) {
      return
    }

    const viewsToSend = [...this.pageViews]
    this.pageViews = []
    this.lastSendTime = Date.now()

    try {
      await postPageViews(viewsToSend)
    } catch (error) {
      console.error('Error sending page views:', error)
    }
  }

  private handleBeforeUnload = () => {
    this.sendPageViews()
  }

  private startTimer () {
    if (this.timerId !== null) {
      clearInterval(this.timerId)
    }
    this.timerId = window.setInterval(() => {
      if (this.pageViews.length > 0 && (Date.now() - this.lastSendTime) / 1000 > SEND_INTERVAL_SECONDS) {
        this.sendPageViews()
      }
    }, SEND_INTERVAL_SECONDS * 1000)
  }
}

export default new PageViewer()
